import { all } from "redux-saga/effects";

import { coachingNoteCategoriesSagas } from "./categories/sagas";
import { coachingFilesSagas } from "./files/sagas";
import { coachingNotesSagas } from "./notes/sagas";
import { coachingNoteWithTaskSagas } from "./noteWithTask/sagas";
import { coachingNotificationsPollingSagas } from "./notificationsPollingSagas";
import { coachingTasksSagas } from "./tasks/sagas";

export function* coachingSagas() {
  yield all([
    coachingNoteCategoriesSagas(),
    coachingFilesSagas(),
    coachingNotesSagas(),
    coachingNoteWithTaskSagas(),
    coachingNotificationsPollingSagas(),
    coachingTasksSagas(),
  ]);
}
